import {getDefaultPieFormatting} from "@/containers/E4ImpactMBA/charts/pie"

const transformData = [
    {
        name: '0-5%',
        value: 'SKILLS_DWT_5',
    },
    {
        name: '6-25%',
        value: 'SKILLS_DWT_25',
    },
    {
        name: '26-50%',
        value: 'SKILLS_DWT_50',
    },
    {
        name: '51-75%',
        value: 'SKILLS_DWT_75',
    },
    {
        name: '76-100%',
        value: 'SKILLS_DWT_100',
    },
];

/**
 * question: In your estimation, how much your participation in the program contributed to these results?
 * 
 * == final
 * skills_dwt
 * 
 * @param props 
 * @returns 
 */
export const contributionChartCalculation = (props: any) => {
    const data = transformData.map(({name, value}) => ({
        name,
        y: props.finalSubmissions.filter((submission: any) => submission.skills_dwt === value).length
    }));

    return getDefaultPieFormatting(
        'E4Impact contribution for results achieved',
        data
    ) as Highcharts.Options;
}